import { useContext } from 'react';
import AppContext from '../components/context/AppContext';

// Constants
const PATH_PARAM_REGEX = /:(\w+)/g;
const PATHS_SEPARATOR = ',';
const TRAILING_SLASH = '/';

/**
 * Get the full path and the path before the parameters
 * @param {string} pathName
 * @returns {{ fullPath: string, pathBeforeParams: string }[]} The full path and the path before the parameters
 */
export default function useDynamicPath({ pathName }) {
    const { appContext } = useContext(AppContext);
    const { config } = appContext;
    if (!config[pathName]) {
        throw new Error(`Path ${pathName} not found in config.`);
    }
    // Split the paths and remove the last slash
    const paths = config[pathName]
        .split(PATHS_SEPARATOR)
        .map((path) => {
            const trimmedPath = path.trim();
            if (trimmedPath.endsWith(TRAILING_SLASH)) {
            // Remove the last slash
                return trimmedPath.slice(0, -1);
            }
            return trimmedPath;
        })
        .filter(Boolean);
    // Get the full path and the path before the parameters
    const result = [];
    for (const path of paths) {
        const searchResult = path.match(PATH_PARAM_REGEX);
        const pathBeforeParams = searchResult 
            ? path.slice(0, path.search(PATH_PARAM_REGEX)) 
            : path;
        result.push({
            fullPath: path,
            pathBeforeParams: pathBeforeParams.endsWith(TRAILING_SLASH) 
                ? pathBeforeParams.slice(0, -1) 
                : pathBeforeParams,
        });
    }
    return result;
}